// Key Highlights store — per-company + per-period, admin-editable.
// Each period (e.g. 'jan-2026') has its own list of bullet points.

const STORAGE_PREFIX = 'finkloz_highlights_';
const CHANGE_EVENT = 'finkloz:highlights-changed';

function key(companyId, period) {
  return `${STORAGE_PREFIX}${companyId || 'default'}_${period || 'default'}`;
}

export function getHighlights(companyId, period) {
  try {
    const raw = localStorage.getItem(key(companyId, period));
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return parsed;
    }
  } catch { /* ignore */ }
  return [];
}

export function saveHighlights(companyId, period, highlights) {
  try {
    localStorage.setItem(key(companyId, period), JSON.stringify(highlights));
    window.dispatchEvent(new Event(CHANGE_EVENT));
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('saveHighlights failed', e);
  }
}

export function subscribeToHighlightsChanges(callback) {
  const handler = () => callback();
  window.addEventListener(CHANGE_EVENT, handler);
  window.addEventListener('storage', handler);
  return () => {
    window.removeEventListener(CHANGE_EVENT, handler);
    window.removeEventListener('storage', handler);
  };
}

export function newHighlightId() {
  return 'hl-' + Math.random().toString(36).slice(2, 9);
}
